import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function offerVisibilityReducer(state = initialState.offerVisible, action) {
  switch (action.type) {
    case types.LOAD_OFFER_USER_PREFERENCES_SUCCESS:
    case types.UPDATE_OFFER_USER_PREFERENCES_SUCCESS:
      return { ...state, userPreferences: Object.assign([], action.payload, { isLoaded: true }) };
    case types.LOAD_OFFER_SELECTED_USER_PREFERENCE_SUCCESS:
    case types.UPDATE_OFFER_SELECTED_USER_PREFERENCE_SUCCESS:
      return { ...state, selectedUserPreference: { ...action.payload, isLoaded: true } };
    case types.LOAD_OFFER_DEFAULT_USER_PREFERENCE_SUCCESS:
      return { ...state, defaultUserPreference: { ...action.payload, isLoaded: true } };
    default:
      return state;
  }
}
